import FieldCost from "./cost"
import FieldConfig from "../../../proto/field-config"

export default class FieldCostExternal extends FieldCost {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Service cost"
        this.typeDescription    = "Service cost field"

        this.label              = _.get(config, 'label', this.typeLabel)

        /*switch (this.entityType) {
            case EntityType.PROJECT:
                this.variableName       = '{PROJECT-SERVICE-COST}'
                break
        }*/
    }
}
